import React, { useState } from "react";
import { Dialog, DialogContent } from "../ui/dialog";
import { Image as ImageIcon, X, Maximize2 } from "lucide-react";

/**
 * ImageViewer — displays a thumbnail preview with click-to-enlarge full-screen dialog.
 * Used to render user-uploaded images across orders and tasks.
 */
export function ImageViewer({ src, label = "Attached image", testid = "image-viewer" }) {
  const [open, setOpen] = useState(false);
  if (!src) return null;
  return (
    <>
      <div data-testid={testid} className="bg-white rounded-2xl border border-slate-100 p-3 space-y-2 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-widest text-slate-400">
            <ImageIcon className="w-3 h-3" strokeWidth={2.6} /> {label}
          </div>
          <button
            onClick={() => setOpen(true)}
            data-testid={`${testid}-expand`}
            className="text-[11px] font-semibold text-emerald-700 hover:text-emerald-800 inline-flex items-center gap-1"
          >
            <Maximize2 className="w-3 h-3" /> Enlarge
          </button>
        </div>
        <button
          onClick={() => setOpen(true)}
          data-testid={`${testid}-thumb`}
          className="w-full block rounded-xl overflow-hidden border border-slate-100 hover:opacity-90 transition"
        >
          <img src={src} alt={label} className="w-full object-cover max-h-64" />
        </button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid={`${testid}-modal`}
          className="max-w-3xl p-2 sm:p-4 rounded-2xl bg-slate-900 border-slate-800"
        >
          <div className="relative">
            <button
              onClick={() => setOpen(false)}
              data-testid={`${testid}-close`}
              className="absolute top-2 right-2 w-9 h-9 rounded-full bg-black/60 hover:bg-black/80 text-white grid place-items-center z-10"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
            <img
              src={src}
              alt={label}
              className="w-full h-auto max-h-[85vh] object-contain rounded-xl"
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
